import type {AxiosResponse} from 'axios';
import {ENVIRONMENTS} from '@apps-common/ui-components';
import {request} from '@src/api/index.js';
import API_URLS, {authTarget} from '@src/api/urls.ts';
import {DURATION_MS} from '@src/api/util.js';
import {useQuery} from '@tanstack/react-query';

const getChameleonIdentity = () =>
  request
    .get(`${API_URLS.explorerUtils}/chameleonIdentity`)
    .then((res: AxiosResponse) => res.data);

export const useGetChameleonIdentity = () =>
  useQuery({
    queryKey: ['chameleonIdentity'],
    queryFn: getChameleonIdentity,
    select: data => data.uid_hash,
    staleTime: DURATION_MS.INFINITY,
    enabled: authTarget === ENVIRONMENTS.production,
  });
